import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {POLL, TENANT_SELECTABLE_POLL} from "../../../../tenant/Config/ApiUrl";

const state = {
    selectable: [],
    called: false,
    poll:{}
}

const actions = {
    getSelectablePolls({commit, state}) {
            commit('SET_CALLED', true);
            axiosGet(`${TENANT_SELECTABLE_POLL}`).then(({data}) => {
                commit('SKILL_POLL_LIST', data)
            });
    },
    getPollDetails({commit, state}, pollId){
        commit('SET_LOADER', true)
        axiosGet(`${POLL}/${pollId}`).then(({ data }) =>{
            commit('POLL_DETAILS_DATA', data)
        }).finally(()=> commit('SET_LOADER', false))
    },
}

const mutations = {
    SKILL_POLL_LIST(state, data) {
        state.selectable = data;
    },
    POLL_DETAILS_DATA(state, data){
        state.poll = data;
    },
    SET_CALLED(state, data) {
        state.called = data;
    }
}

export default {
    state,
    actions,
    mutations
}
